import { type FlowAction } from '../types';
import { useTranslation } from '../i18n/i18n';

/**
 * The secondary action of a flow screen: "Go back" when there is a previous
 * step to return to, otherwise "Cancel".
 */
export function useBackOrCancel(
  onCancel: () => void,
  onBack?: () => void,
): FlowAction {
  const { t } = useTranslation();
  return onBack
    ? { label: t('abort.goBack'), onClick: onBack }
    : { label: t('agentStart.cancel'), onClick: onCancel };
}
